import { createMuiTheme } from "@material-ui/core";
import { darkPalette, palette } from "./palette";
import { shadows } from "./shadows";
import { typography } from "./typography";
export const theme = (dark) => createMuiTheme({
    palette: dark ? darkPalette : palette,
    shadows,
    typography,
});
//# sourceMappingURL=index.js.map